import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Row,
  Form,
  Input,
  DatePicker,
  Tooltip,
  Select,
} from "antd";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plusicon.svg";
import styled from "styled-components";
import Table from "atoms/Table";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import { NON_EMPTY_REGEX } from "common/Constants";
import TextArea from "antd/lib/input/TextArea";
import RoleAccountant from "../RoleAccountant";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Viewcompleted from "pages/PerformanceMnagement/Viewperformance/Viewcompleted";
import PerformanceMatrix from "pages/PerformanceMnagement/Viewperformance/PerformanceMatrix";
import { DeleteOutlined } from "@mui/icons-material";
import { ReactComponent as TrashDelete } from "assets/Trash_Full.svg";
const ItemsColored = styled.div`
  .plusicon_btn_container {
    margin: 20px 0 0;
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .technicalAssessment {
    margin-top: 30px;
    width: 100%;
  }
  .technicalAssessment__title {
    font-size: 16px;
    font-weight: 600;
    padding-bottom: 20px;
  }
  .technicalAssessment__responsibilities {
    width: 50%;
    display: flex;
  }
  .technicalAssessment__responsibilitiesTitle {
    font-size: 16px;
    font-weight: 400;
  }

  .technicalAssessment__responsibilitiesTitle,
  .Weightage_container {
    font-size: 16px;
    font-weight: 400;
  }
  .Weightage_container {
    font-size: 16px;
    font-weight: 500;
    color: #636980;
    padding-left: 15px;
  }
  .container_main {
    display: flex;
    width: 100%;
    background-color: rgb(248, 248, 248);
    padding: 14px;
    border-radius: 20px;
  }
  .leftSection {
    width: 50%;
  }
  .rightSection {
    width: 50%;
    display: flex;
    flex-direction: column;
  }
  .technicalAssessment__selfScore {
    display: flex;
    width: 100%;
    margin: 7px 0;
  }
  .technicalAssessment__selfScoreTitle,
  .technicalAssessment__selfScoreValue {
    font-size: 14px;
    font-weight: 500;
    color: #000;
  }
  .technicalAssessment__selfScoreTitle {
    width: 30%;
  }
  .technicalAssessment__selfScoreValue {
    width: 70%;
  }
  .section-title {
    font-weight: 600;
    font-size: 16px;
    padding-bottom: 10px;
    padding-top: 10px;
  }
`;

const Wrap = styled.div`
  .ant-input {
    border: none;
    background: none;
  }
`;

const SoftSkillWrap = styled.div`
  .soft-skills-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 16px 0;
  }

  .line {
    flex: 1;
    height: 1px;
    background-color: #d9d9d9;
    margin: 0 8px;
  }

  .soft-skills-text {
    font-size: 16px;
    font-weight: 500;
    color: #2c2c2c;
    white-space: nowrap;
  }
`;

const ButtonCancel = styled(Button)`
  padding: 5px 20px;
  border-radius: 5px;
  background: transparent;
  font-weight: 600;
  color: #000000;
  white-space: nowrap;
  margin: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  &:hover {
    background: transparent;
    color: #000000;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border: none;
    outline: none;
  }

  &:focus {
    background: #f1f3f4;
    color: #000000;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    border: none;
    outline: none;
  }

  @media (max-width: 900px) {
    margin: 10px 0px;
  }
`;

const Evaluation = ({
  appraisalIndex,
  appraisalInformation,
  validationErrors,
  handleChange,
  technicalAssessmentData,
  handleAddRow,
  appraisalDetails,
  selectedSegment,
  onFinish,
  setTechnicalAssessmentTable,
  setBdoValuesTable,
  tabId,
  setTabId,
  technicalAssessmentTable,
  bdoValuesTable,
  roleTypes,
  tab,
  activeTabId,
  primaryAppraiser,
  setAppraisalIndex,
  handleDeleteRow,
  loading,
}) => {
  const [form] = Form.useForm();
  const history = useHistory();

  const columns = [
    {
      title: "Target Objectives Given During Previous Appraisal",
      dataIndex: "previousObjectives",
      key: "previousObjectives",
      render: (text, record) => (
        <Input
          placeholder="Enter objectives..."
          disabled={primaryAppraiser && !roleTypes.includes(selectedSegment)}
          onChange={(event) =>
            handleChange(event.target.value, record, "previousObjectives")
          }
          value={record.previousObjectives}
          style={{
            border: validationErrors?.[
              appraisalInformation?.[appraisalIndex - 1]?.roletype
            ]?.[record.id]?.previousObjectives
              ? "1px solid red"
              : "",
          }}
        />
      ),
    },
    {
      title: "Expected Outcomes",
      dataIndex: "expectedOutcomes",
      key: "expectedOutcomes",
      render: (text, record) => (
        <Input
          placeholder="Enter expected outcomes..."
          disabled={primaryAppraiser && !roleTypes.includes(selectedSegment)}
          value={record.expectedOutcomes}
          onChange={(event) =>
            handleChange(event.target.value, record, "expectedOutcomes")
          }
          style={{
            border: validationErrors?.[
              appraisalInformation?.[appraisalIndex - 1]?.roletype
            ]?.[record.id]?.expectedOutcomes
              ? "1px solid red"
              : "",
          }}
        />
      ),
    },
    {
      title: "Target Date",
      dataIndex: "targetDate",
      key: "targetDate",
      width: "20%",
      render: (text, record) => (
        <DatePicker
          format={"DD-MM-YYYY"}
          placeholder="Enter target date..."
          disabled={primaryAppraiser && !roleTypes.includes(selectedSegment)}
          value={
            record.targetDate ? moment(record.targetDate, "DD-MM-YYYY") : null
          }
          onChange={(date, dateString) =>
            handleChange(dateString, record, "targetDate")
          }
          style={{
            width: "150px",
            border: validationErrors?.[
              appraisalInformation?.[appraisalIndex - 1]?.roletype
            ]?.[record.id]?.targetDate
              ? "1px solid red"
              : "",
          }}
        />
      ),
    },
    {
      title: "Agreed Remedial Actions",
      dataIndex: "remedialActions",
      key: "remedialActions",
      render: (text, record) => (
        <Input
          placeholder="Enter remedial actions..."
          disabled={primaryAppraiser && !roleTypes.includes(selectedSegment)}
          value={record.remedialActions}
          onChange={(event) =>
            handleChange(event.target.value, record, "remedialActions")
          }
        />
      ),
    },
    {
      title: "Expected Outcomes",
      dataIndex: "actionoxpectedoutcomes",
      key: "actionoxpectedoutcomes",
      render: (text, record) => (
        <Input
          placeholder="Enter action expected outcomes..."
          disabled={primaryAppraiser && !roleTypes.includes(selectedSegment)}
          value={record.actionoxpectedoutcomes}
          onChange={(event) =>
            handleChange(event.target.value, record, "actionoxpectedoutcomes")
          }
        />
      ),
    },
    {
      title: "Target Date",
      dataIndex: "actiontargetdate",
      key: "actiontargetdate",
      width: "20%",
      render: (text, record) => (
        <DatePicker
          format={"DD-MM-YYYY"}
          placeholder="Enter target date..."
          disabled={primaryAppraiser && !roleTypes.includes(selectedSegment)}
          value={
            record.actiontargetdate
              ? moment(record.actiontargetdate, "DD-MM-YYYY")
              : null
          }
          onChange={(date, dateString) =>
            handleChange(dateString, record, "actiontargetdate")
          }
          style={{ width: "150px" }}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record, index) => (
        <Button disabled={index === 0}>
          <TrashDelete
            disabled={index === 0}
            onClick={() => handleDeleteRow(record.id)}
          >
            Delete
          </TrashDelete>
        </Button>
      ),
    },
  ];

  const footerStyle = {
    position: "sticky",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px -20px",
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  let reviewtechnicalassessment = Object.keys(
    appraisalDetails?.technicalassessment
  ).find((key) => key === selectedSegment);
  let reviewbdovalues = Object.keys(appraisalDetails?.bdovalues).find(
    (key) => key === selectedSegment
  );

  let reviewmatrixtechnicalassessmentValue =
    appraisalDetails?.technicalassessment[reviewtechnicalassessment];
  let reviewmatrixbdovaluesValue = appraisalDetails?.bdovalues[reviewbdovalues];

  const sumReviewAppraiserScores = reviewmatrixtechnicalassessmentValue.reduce(
    (sum, item) => sum + item.appraiserscore * parseFloat(item.weightage),
    0
  );

  const sumReviewBdoScores = reviewmatrixbdovaluesValue.reduce(
    (sum, item) => sum + item.appraiserscore * parseFloat(item.weightage),
    0
  );

  const technicalAssessment =
    appraisalDetails?.technicalassessment?.[selectedSegment];

  const [sumAppraiserScores, setSumAppraiserScores] = useState(0);
  const [sumBdoValuesScores, setSumBdoValuesScores] = useState(0);

  const calculateScores = () => {
    const weightages =
      technicalAssessment?.map((item) => parseInt(item.weightage)) || [];

    const sumAppraiser =
      (form?.getFieldValue("appraiserscore-0") || 0) * (weightages[0] || 0) +
      (form?.getFieldValue("appraiserscore-1") || 0) * (weightages[1] || 0) +
      (form?.getFieldValue("appraiserscore-2") || 0) * (weightages[2] || 0) +
      (form?.getFieldValue("appraiserscore-3") || 0) * (weightages[3] || 0);

    const sumBdoValues =
      (form?.getFieldValue("bdovaluesappraiserscore-0") || 0) * 20 +
      (form?.getFieldValue("bdovaluesappraiserscore-1") || 0) * 15 +
      (form?.getFieldValue("bdovaluesappraiserscore-2") || 0) * 15 +
      (form?.getFieldValue("bdovaluesappraiserscore-3") || 0) * 15 +
      (form?.getFieldValue("bdovaluesappraiserscore-4") || 0) * 15 +
      (form?.getFieldValue("bdovaluesappraiserscore-5") || 0) * 20;

    setSumAppraiserScores(sumAppraiser);
    setSumBdoValuesScores(sumBdoValues);
  };

  useEffect(() => {
    calculateScores();
  }, [form]);

  const handleEvaluationFormChange = (values, roletype) => {
    calculateScores();

    const technicalAssessmentData = appraisalDetails?.technicalassessment[
      roletype
    ]?.map((item, index) => ({
      id: item.id,
      objectives: item.objectives,
      weightage: item.weightage,
      whatwentwellmajorachivement: item?.whatwentwellmajorachivement,
      whatdidnotgowellchallenges: item?.whatdidnotgowellchallenges,
      selfscore: item?.selfscore,
      appraiserscore: values[`appraiserscore-${index}`],
      appraiserremarks: values[`appraiserremarks-${index}`],
    }));

    const bdoValuesData = appraisalDetails?.bdovalues[roletype]?.map(
      (item, index) => ({
        id: item.id,
        objectives: item.objectives,
        weightage: item.weightage,
        whatwentwellmajorachivement: item?.whatwentwellmajorachivement,
        whatdidnotgowellchallenges: item?.whatdidnotgowellchallenges,
        selfscore: item?.selfscore,
        appraiserscore: values[`bdovaluesappraiserscore-${index}`],
        appraiserremarks: values[`bdovaluesappraiserremarks-${index}`],
      })
    );

    setTechnicalAssessmentTable((prevState) => ({
      ...prevState,
      [roletype]: technicalAssessmentData || [],
    }));

    setBdoValuesTable((prevState) => ({
      ...prevState,
      [roletype]: bdoValuesData || [],
    }));
  };

  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [tabId]);

  return (
    <>
      <Row gutter={16}>
        <Col xl={24} sm={24}>
          <div style={{ fontSize: "16px", fontWeight: "600" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p>Key Responsibilities / Target / Strategic Objectives</p>
              <div>
                <RoleAccountant />
              </div>
            </div>
          </div>

          <Wrap>
            <Table
              dataSource={technicalAssessmentData[selectedSegment]}
              columns={columns}
              className="small_table"
              rowKey="key"
              pagination={false}
              footer={() => (
                <div>
                  <Button
                    type="dashed"
                    onClick={handleAddRow}
                    disabled={
                      primaryAppraiser && !roleTypes.includes(selectedSegment)
                    }
                  >
                    + Add Another (Max 10 rows)
                  </Button>
                </div>
              )}
            />
          </Wrap>
        </Col>
      </Row>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onValuesChange={(_, values) => {
          handleEvaluationFormChange(values, selectedSegment);
        }}
        onFinishFailed={onFinishFailed}
        initialValues={{
          ...technicalAssessmentTable[selectedSegment]?.reduce(
            (acc, item, index) => ({
              ...acc,
              [`appraiserscore-${index}`]: item.appraiserscore,
              [`appraiserremarks-${index}`]: item.appraiserremarks,
            }),
            {}
          ),
          ...bdoValuesTable[selectedSegment]?.reduce(
            (acc, item, index) => ({
              ...acc,
              [`bdovaluesappraiserscore-${index}`]: item.appraiserscore,
              [`bdovaluesappraiserremarks-${index}`]: item.appraiserremarks,
            }),
            {}
          ),
        }}
      >
        <ItemsColored>
          <Row gutter={16}>
            <Col xl={24} sm={24}>
              <div className="technicalAssessment__title">
                Technical Assessment
              </div>
              {appraisalDetails?.technicalassessment[selectedSegment]?.map(
                (item, index) => (
                  <div
                    className="mb-2"
                    key={`technicalAssessment-${selectedSegment}-${index}`}
                  >
                    <div className="technicalAssessment__responsibilities">
                      <p className="technicalAssessment__responsibilitiesTitle">
                        {item?.objectives}
                      </p>
                      <p className="Weightage_container">
                        (Weightage {item?.weightage}%)
                      </p>
                    </div>
                    <div className="container_main individual_assessment_containerone">
                      <div className="leftSection">
                        <div className="technicalAssessment__selfScore">
                          <p className="technicalAssessment__selfScoreTitle">
                            Self Score
                          </p>
                          <p className="technicalAssessment__selfScoreValue">
                            {item?.selfscore}
                          </p>
                        </div>
                        <div className="technicalAssessment__selfScore">
                          <p className="technicalAssessment__selfScoreTitle">
                            Achievements
                          </p>
                          <p className="technicalAssessment__selfScoreValue">
                            {item?.whatwentwellmajorachivement}
                          </p>
                        </div>
                        <div className="technicalAssessment__selfScore">
                          <p className="technicalAssessment__selfScoreTitle">
                            Challenges
                          </p>
                          <p className="technicalAssessment__selfScoreValue">
                            {item?.whatdidnotgowellchallenges}
                          </p>
                        </div>
                      </div>
                      <div className="rightSection">
                        <Form.Item
                          name={`appraiserscore-${index}`}
                          label="Appraiser’s Score"
                          rules={[
                            {
                              required: true,
                              pattern: NON_EMPTY_REGEX,
                              message: "Appraiser's Score is required",
                            },
                            {
                              validator: (_, value) => {
                                if (value && Number(value) > item.weightage) {
                                  return Promise.reject(
                                    `Value cannot be greater than ${item.weightage}%`
                                  );
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select Individual Assess Appraiser's Score"
                            disabled={
                              primaryAppraiser &&
                              !roleTypes.includes(selectedSegment)
                            }
                          >
                            {[1, 2, 3, 4, 5, 6].map((value) => (
                              <Select.Option key={value} value={value}>
                                {value}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          name={`appraiserremarks-${index}`}
                          label="Appraiser’s Remark"
                          rules={[
                            {
                              required: true,
                              pattern: NON_EMPTY_REGEX,
                              message: "Appraiser's Remark is required",
                            },
                          ]}
                        >
                          <TextArea
                            placeholder="Enter Appraiser's Remark"
                            disabled={
                              primaryAppraiser &&
                              !roleTypes.includes(selectedSegment)
                            }
                            maxLength={500}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                )
              )}
            </Col>
          </Row>
        </ItemsColored>

        <ItemsColored>
          <Row gutter={16}>
            <Col xl={24} sm={24}>
              <div className="technicalAssessment__title">
                Individual (soft skills) Assessment / (BDO VALUES)
              </div>
              {appraisalDetails?.bdovalues[selectedSegment]?.map(
                (item, index) => (
                  <div
                    className="mb-2"
                    key={`bdovalues-${selectedSegment}-${index}`}
                  >
                    <div className="technicalAssessment__responsibilities">
                      <p className="technicalAssessment__responsibilitiesTitle">
                        {item?.objectives}
                      </p>
                      <p className="Weightage_container">
                        (Weightage {item?.weightage}%)
                      </p>
                    </div>
                    <div className="container_main individual_assessment_containerone">
                      <div className="leftSection">
                        <div className="technicalAssessment__selfScore">
                          <p className="technicalAssessment__selfScoreTitle">
                            Self Score
                          </p>
                          <p className="technicalAssessment__selfScoreValue">
                            {item?.selfscore}
                          </p>
                        </div>
                        <div className="technicalAssessment__selfScore">
                          <p className="technicalAssessment__selfScoreTitle">
                            Achievements
                          </p>
                          <p className="technicalAssessment__selfScoreValue">
                            {item?.whatwentwellmajorachivement}
                          </p>
                        </div>
                        <div className="technicalAssessment__selfScore">
                          <p className="technicalAssessment__selfScoreTitle">
                            Challenges
                          </p>
                          <p className="technicalAssessment__selfScoreValue">
                            {item?.whatdidnotgowellchallenges}
                          </p>
                        </div>
                      </div>
                      <div className="rightSection">
                        <Form.Item
                          name={`bdovaluesappraiserscore-${index}`}
                          label="Appraiser’s Score"
                          rules={[
                            {
                              required: true,
                              pattern: NON_EMPTY_REGEX,
                              message: "Appraiser's Score is required",
                            },
                            {
                              validator: (_, value) => {
                                if (value && Number(value) > item.weightage) {
                                  return Promise.reject(
                                    `Value cannot be greater than ${item.weightage}%`
                                  );
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select BDO Values Appraiser's Score"
                            disabled={
                              primaryAppraiser &&
                              !roleTypes.includes(selectedSegment)
                            }
                          >
                            {[1, 2, 3, 4, 5, 6].map((value) => (
                              <Select.Option key={value} value={value}>
                                {value}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          name={`bdovaluesappraiserremarks-${index}`}
                          label="Appraiser’s Remark"
                          rules={[
                            {
                              required: true,
                              pattern: NON_EMPTY_REGEX,
                              message: "Appraiser's Remark is required",
                            },
                          ]}
                        >
                          <TextArea
                            placeholder="Enter Appraiser's Remark"
                            disabled={
                              primaryAppraiser &&
                              !roleTypes.includes(selectedSegment)
                            }
                            maxLength={500}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                )
              )}
            </Col>
          </Row>
        </ItemsColored>
        {activeTabId === "1" && (
          <PerformanceMatrix
            Xaxis={sumBdoValuesScores / 100}
            Yaxis={sumAppraiserScores / 100}
          />
        )}

        {activeTabId === "2" && (
          <PerformanceMatrix
            Xaxis={sumReviewBdoScores / 100}
            Yaxis={sumReviewAppraiserScores / 100}
          />
        )}

        <div style={footerStyle}>
          <ButtonCancel
            style={{ width: "130px", height: "35px" }}
            onClick={() =>
              history.push(`/evaluatedresponse/${appraisalDetails?.contractid}`)
            }
          >
            Cancel
          </ButtonCancel>
          {activeTabId === "1" && (
            <>
              <ButtonCancel
                onClick={() => {
                  setTabId(tabId - 1);
                  setAppraisalIndex(appraisalIndex <= 0 ? 1 : appraisalIndex);
                }}
                style={{ width: "130px", height: "35px" }}
              >
                Previous
              </ButtonCancel>
              <ButtonFilled
                htmlType="submit"
                style={{ width: "130px", height: "35px" }}
              >
                Next
              </ButtonFilled>
            </>
          )}
          {activeTabId === "2" && (
            <ButtonFilled
              style={{ width: "130px", height: "35x" }}
              htmlType="submit"
              loading={loading}
              disabled={
                primaryAppraiser && !roleTypes.includes(selectedSegment)
              }
            >
              {"Save Changes"}
            </ButtonFilled>
          )}
        </div>
      </Form>
    </>
  );
};

export default Evaluation;
